import { selectFromUserInviteDto } from '../../models';

export default selectFromUserInviteDto()
  .uuid
  .fullname
  .email
  .inviteStatusId
  .invitedBy
  .organizationId
  .role(r => r.id.name)
  .createdOn
  .expiresOn
  .toString();
